function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import moment from "moment-timezone";
import { FilterContext, UserContext } from "../index";
import Loader from "./../Loader/Loader";
import { useTable, useSortBy } from "react-table";
import Dropdown from "react-bootstrap/Dropdown";
import classNames from "classnames";
import Button from "react-bootstrap/Button";
import "./ProjectReport.css";
import { HiDownload, HiOutlineSelector, HiChevronDown, HiChevronUp } from "react-icons/hi";
import { USER_LISTING_QUERY, PROJECTS_LISTING_QUERY } from "./../ManualPages/query";
import { GET_TASK_TRACKER_QUERY, GET_EXPORT_TASK_TRACKER_QUERY } from "./query";
import { useQuery, useLazyQuery } from "@apollo/client";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import SearchBar from "../SearchBar";
import { arrayToStringOutput } from "./../SideMenu/Header";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import { TimeFilter } from "./DateFilter";
import { ProjectEnableSection } from "./../MyProjects/MyProjects";
var LIMIT = 10;
var offsets = 0;
var ProjectReport = function ProjectReport(props) {
  var _userListData$getProj, _taskTrackerData$getR, _taskTrackerData$getR2, _taskTrackerData$getR3, _taskTrackerData$getR4, _taskTrackerData$getR5, _taskTrackerData$getR6, _projectListing$proje, _projectListing$proje2, _taskTrackerData$getR7, _taskTrackerData$getR8, _taskTrackerData$getR9, _taskTrackerData$getR10;
  var _React$useState = React.useState({
      startDate: new Date(),
      endDate: null
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    dates = _React$useState2[0],
    setDate = _React$useState2[1];

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  //loadmore
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isAllLoaded = _React$useState4[0],
    setIsAllLoaded = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isLoadingMore = _React$useState6[0],
    setIsLoadingMore = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isLoadMoreButton = _React$useState8[0],
    setIsLoadMoreButton = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    exportButton = _React$useState10[0],
    setExportButton = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isNavClick = _React$useState12[0],
    setNavClick = _React$useState12[1];
  var _React$useState13 = React.useState([]),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    userActive = _React$useState14[0],
    setUserActive = _React$useState14[1];
  var _React$useState15 = React.useState([]),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    projectActive = _React$useState16[0],
    setProjectActive = _React$useState16[1];
  var _React$useState17 = React.useState([]),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    taskActive = _React$useState18[0],
    setTaskActive = _React$useState18[1];
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    from = _React$useContext.from,
    organisationStatus = _React$useContext.organisationStatus;
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  var startDate = dates.startDate,
    endDate = dates.endDate;
  var _React$useState19 = React.useState(arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    filterData = _React$useState20[0],
    setFilterData = _React$useState20[1];
  React.useEffect(function () {
    if (from == "web" && role == "Member" && organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.allowMemberToAccessTimesheet) {
      props === null || props === void 0 ? void 0 : props.history.push("/timesheet");
    }
    if (from == "web" && role == "Member" && organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.manualTimeFeature) {
      props === null || props === void 0 ? void 0 : props.history.push("/manual-time");
    }
    if (role === "Member" && !organisationSettings.projectManagementFeature) {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var columns = React.useMemo(function () {
    return [{
      Header: "Sno",
      accessor: "sno"
    }, {
      Header: "Date",
      accessor: "date"
    }, {
      Header: "Project Name",
      accessor: "projectName"
    }, {
      Header: "Task Name",
      accessor: "taskName"
    }, {
      Header: "Member",
      accessor: "displayName"
    }, {
      Header: "Hours Worked (hh:mm:ss)",
      accessor: "totalWorkHours"
    }, {
      Header: "Billable Rate ",
      accessor: "userBillableRate"
    }, {
      Header: "Labour Cost ",
      accessor: "userLabourCost"
    }, {
      Header: "Profit ",
      accessor: "profit"
    }];
  }, []);
  var userList = [{
    label: "All Member",
    value: ""
  }];
  var _useQuery = useQuery(USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        role: role
      },
      skip: !teamId || !organisationId
    }),
    userListData = _useQuery.data,
    userListError = _useQuery.error,
    userListLoading = _useQuery.loading;
  var _useQuery2 = useQuery(PROJECTS_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        from: props !== null && props !== void 0 && props.from ? "desktop" : null,
        role: role
      },
      skip: !organisationId || !teamId
    }),
    projectListing = _useQuery2.data,
    projectListingError = _useQuery2.error,
    projectListingLoading = _useQuery2.loading,
    projectRefetch = _useQuery2.refetch;
  var _useQuery3 = useQuery(GET_TASK_TRACKER_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: userActive.length ? userActive : null,
        projectId: projectActive.length ? projectActive : null,
        taskId: taskActive.length ? taskActive : null,
        limit: LIMIT,
        offset: 0,
        startDate: Number(moment(startDate).format("x")),
        endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
      },
      skip: !teamId || !organisationId
    }),
    taskTrackerData = _useQuery3.data,
    taskTrackerError = _useQuery3.error,
    taskTrackerLoading = _useQuery3.loading,
    fetchMore = _useQuery3.fetchMore,
    taskRefetch = _useQuery3.refetch;
  React.useEffect(function () {
    setIsAllLoaded(false);
    setIsLoadingMore(false);
    setIsLoadMoreButton(false);
    offsets = 0;
  }, [userActive, projectActive, taskActive, startDate, endDate]);
  var _useLazyQuery = useLazyQuery(GET_EXPORT_TASK_TRACKER_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getExport = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    exportLoading = _useLazyQuery2$.loading,
    exportData = _useLazyQuery2$.data;
  userListData === null || userListData === void 0 ? void 0 : (_userListData$getProj = userListData.getProjectUser) === null || _userListData$getProj === void 0 ? void 0 : _userListData$getProj.map(function (item) {
    var userId = item.userId,
      displayName = item.displayName;
    return userList.push({
      label: displayName,
      value: userId
    });
  });
  var dataTable = taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getR = taskTrackerData.getReportTaskTrackerDetails) === null || _taskTrackerData$getR === void 0 ? void 0 : (_taskTrackerData$getR2 = _taskTrackerData$getR.taskTrackerDatas) === null || _taskTrackerData$getR2 === void 0 ? void 0 : _taskTrackerData$getR2.map(function (d, index) {
    var user = d.user,
      totalTime = d.totalTime,
      taskName = d.taskName,
      projectName = d.projectName,
      taskDate = d.taskDate,
      userBillableRate = d.userBillableRate,
      userLabourCost = d.userLabourCost,
      profit = d.profit;
    return {
      sno: index + 1,
      displayName: user.displayName,
      totalWorkHours: totalTime,
      taskName: taskName,
      projectName: projectName,
      date: moment(taskDate).format("DD MMM YYYY"),
      userBillableRate: userBillableRate ? userBillableRate : "NA",
      userLabourCost: userLabourCost ? userLabourCost : "NA",
      profit: profit ? profit : "NA"
    };
  });
  var handleDateChange = function handleDateChange(date) {
    var _date = _slicedToArray(date, 2),
      startDate = _date[0],
      endDate = _date[1];
    setDate({
      startDate: startDate,
      endDate: endDate
    });
  };
  var handleLoadMore = function handleLoadMore() {
    if (taskTrackerLoading) return;
    setIsLoadingMore(true);
    offsets = offsets + 1;
    fetchMore({
      variables: {
        offset: offsets * LIMIT
      },
      updateQuery: function updateQuery(prev, _ref) {
        var _fetchMoreResult$getR, _fetchMoreResult$getR2, _fetchMoreResult$getR3;
        var fetchMoreResult = _ref.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$getR = fetchMoreResult.getReportTaskTrackerDetails) === null || _fetchMoreResult$getR === void 0 ? void 0 : (_fetchMoreResult$getR2 = _fetchMoreResult$getR.taskTrackerDatas) === null || _fetchMoreResult$getR2 === void 0 ? void 0 : _fetchMoreResult$getR2.length) === 0 && ((_fetchMoreResult$getR3 = fetchMoreResult.getReportTaskTrackerDetails) === null || _fetchMoreResult$getR3 === void 0 ? void 0 : _fetchMoreResult$getR3.taskTrackerDatas.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          getReportTaskTrackerDetails: _objectSpread(_objectSpread({}, prev.getReportTaskTrackerDetails), {}, {
            taskTrackerDatas: [].concat(_toConsumableArray(prev.getReportTaskTrackerDetails.taskTrackerDatas), _toConsumableArray(fetchMoreResult.getReportTaskTrackerDetails.taskTrackerDatas)),
            totalWorkedHours: fetchMoreResult.getReportTaskTrackerDetails.totalWorkedHours
          })
        });
      }
    });
  };
  if ((taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getR3 = taskTrackerData.getReportTaskTrackerDetails) === null || _taskTrackerData$getR3 === void 0 ? void 0 : (_taskTrackerData$getR4 = _taskTrackerData$getR3.taskTrackerDatas) === null || _taskTrackerData$getR4 === void 0 ? void 0 : _taskTrackerData$getR4.length) !== 0 && (taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getR5 = taskTrackerData.getReportTaskTrackerDetails) === null || _taskTrackerData$getR5 === void 0 ? void 0 : (_taskTrackerData$getR6 = _taskTrackerData$getR5.taskTrackerDatas) === null || _taskTrackerData$getR6 === void 0 ? void 0 : _taskTrackerData$getR6.length) < LIMIT && !isAllLoaded) {
    setIsAllLoaded(true);
  }
  var getExportData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setExportButton(true);
            getExport({
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: userActive.length ? userActive : null,
                projectId: projectActive.length ? projectActive : null,
                taskId: taskActive.length ? taskActive : null,
                startDate: Number(moment(startDate).format("x")),
                endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
              }
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getExportData() {
      return _ref2.apply(this, arguments);
    };
  }();
  var csvData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var _exportData$getExport, _exportData$getExport2, _exportData$getExport3, _exportData$getExport4, _exportData$getExport5, _exportData$getExport6, _exportData$getExport7, _exportData$getExport8;
    var dataArray, dataValues, wb, ws, row, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          dataArray = [];
          dataValues = exportData === null || exportData === void 0 ? void 0 : (_exportData$getExport = exportData.getExportReportTaskTrackerDetails) === null || _exportData$getExport === void 0 ? void 0 : _exportData$getExport.taskTrackerDatas;
          if (dataValues) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return", []);
        case 4:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          ws.columns = [{
            header: "Date",
            key: "date",
            width: 10,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Project",
            key: "project",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Task",
            key: "task",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Member",
            key: "member",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Hours Worked (hh:mm:ss)",
            key: "hours",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Billable Rate ",
            key: "userBillableRate",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Labour Cost ",
            key: "userLabourCost",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Profit ",
            key: "profit",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          dataValues.map(function (users, index) {
            var user = users.user,
              totalTime = users.totalTime,
              taskName = users.taskName,
              projectName = users.projectName,
              taskDate = users.taskDate,
              userBillableRate = users.userBillableRate,
              userLabourCost = users.userLabourCost,
              profit = users.profit;
            ws.addRow({
              date: moment(taskDate).format("DD MMM YYYY"),
              project: projectName,
              task: taskName,
              member: user.displayName,
              hours: totalTime,
              userBillableRate: userBillableRate ? userBillableRate : "NA",
              userLabourCost: userLabourCost ? userLabourCost : "NA",
              profit: profit ? profit : "NA"
            });
          });
          row = ws.addRow({
            date: "",
            project: "",
            task: "",
            member: "Total Worked Hours",
            hours: exportData === null || exportData === void 0 ? void 0 : (_exportData$getExport2 = exportData.getExportReportTaskTrackerDetails) === null || _exportData$getExport2 === void 0 ? void 0 : _exportData$getExport2.totalWorkedHours,
            userBillableRate: (exportData === null || exportData === void 0 ? void 0 : (_exportData$getExport3 = exportData.getExportReportTaskTrackerDetails) === null || _exportData$getExport3 === void 0 ? void 0 : _exportData$getExport3.totalBillableRate) !== "$0" ? exportData === null || exportData === void 0 ? void 0 : (_exportData$getExport4 = exportData.getExportReportTaskTrackerDetails) === null || _exportData$getExport4 === void 0 ? void 0 : _exportData$getExport4.totalBillableRate : "",
            userLabourCost: (exportData === null || exportData === void 0 ? void 0 : (_exportData$getExport5 = exportData.getExportReportTaskTrackerDetails) === null || _exportData$getExport5 === void 0 ? void 0 : _exportData$getExport5.totalLabourCost) !== "$0" ? exportData === null || exportData === void 0 ? void 0 : (_exportData$getExport6 = exportData.getExportReportTaskTrackerDetails) === null || _exportData$getExport6 === void 0 ? void 0 : _exportData$getExport6.totalLabourCost : "",
            profit: (exportData === null || exportData === void 0 ? void 0 : (_exportData$getExport7 = exportData.getExportReportTaskTrackerDetails) === null || _exportData$getExport7 === void 0 ? void 0 : _exportData$getExport7.totalProfit) !== "$0" ? exportData === null || exportData === void 0 ? void 0 : (_exportData$getExport8 = exportData.getExportReportTaskTrackerDetails) === null || _exportData$getExport8 === void 0 ? void 0 : _exportData$getExport8.totalProfit : ""
          });
          row.font = {
            bold: true
          };
          ws.getCell("A1").font = {
            bold: true
          };
          ws.getCell("B1").font = {
            bold: true
          };
          ws.getCell("C1").font = {
            bold: true
          };
          ws.getCell("D1").font = {
            bold: true
          };
          ws.getCell("E1").font = {
            bold: true
          };
          ws.getCell("F1").font = {
            bold: true
          };
          ws.getCell("G1").font = {
            bold: true
          };
          ws.getCell("H1").font = {
            bold: true
          };
          _context2.next = 20;
          return wb.xlsx.writeBuffer();
        case 20:
          buf = _context2.sent;
          fileName = "workfolio-project-report-".concat(moment(startDate).format("DD MMM YYYY"), ".xlsx");
          saveAs(new Blob([buf]), fileName);
          setExportButton(false);
        case 24:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [exportData]);
  React.useEffect(function () {
    csvData();
  }, [exportData]);
  var onFilterChange = function onFilterChange(dates) {
    setDate(dates);
  };
  var hideOverlay = function hideOverlay() {
    var _document, _document$body, _document$body$click;
    (_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : (_document$body$click = _document$body.click) === null || _document$body$click === void 0 ? void 0 : _document$body$click.call(_document$body);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !organisationSettings.projectManagementFeature ? /*#__PURE__*/React.createElement(ProjectEnableSection, {
    user: user,
    organisationId: organisationId,
    organisationSettings: organisationSettings,
    filterId: null,
    role: role,
    pageName: "project-report",
    isTaskViewCheck: null,
    teamId: teamId,
    projectIds: null,
    taskIds: null,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    last14Days: null,
    from: null,
    propsUserId: null,
    userIds: null,
    userActive: userActive,
    projectActive: projectActive,
    taskActive: taskActive,
    startDate: Number(moment(startDate).format("x")),
    endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
    projectId: null,
    userUrl: null
  }) : /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-report-filter-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-reports-filter-root-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-report-filter-user"
  }, /*#__PURE__*/React.createElement(Dropdown, {
    open: isNavClick,
    className: classNames("project-report-users-button-date .btn-primary")
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basics"
  }, arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: "page-content-wrapper-menu-filter-overlay-trigger"
  }, /*#__PURE__*/React.createElement(TimeFilter, {
    onFilterChange: onFilterChange,
    startDate: startDate,
    endDate: endDate,
    filterData: filterData,
    onClose: hideOverlay,
    organisationBilling: organisationBilling,
    organisationSettings: organisationSettings
  }))), /*#__PURE__*/React.createElement(Dropdown, {
    open: isNavClick,
    className: classNames("project-report-users-button .btn-primary")
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basics"
  }, "Employee ", userActive.length ? " (".concat(userActive.length, ") ") : null), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: "project-report-dropdown-menu-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-report-drop-text"
  }, /*#__PURE__*/React.createElement(ProjectAndTaskList, {
    isNavClick: isNavClick,
    setNavClick: setNavClick,
    projectListing: userListData === null || userListData === void 0 ? void 0 : userListData.getProjectUser,
    userActive: userActive,
    setUserActive: setUserActive,
    projectActive: projectActive,
    setProjectActive: setProjectActive,
    type: "user",
    setTaskActive: setTaskActive,
    taskActive: taskActive
  })))), /*#__PURE__*/React.createElement(Dropdown, {
    open: isNavClick,
    className: classNames("project-report-users-button .btn-primary")
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basics"
  }, "Project ", projectActive.length ? " (".concat(projectActive.length, ") ") : null, " "), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: "project-report-dropdown-menu-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-report-drop-text"
  }, /*#__PURE__*/React.createElement(ProjectAndTaskList, {
    isNavClick: isNavClick,
    setNavClick: setNavClick,
    projectListing: projectListing === null || projectListing === void 0 ? void 0 : (_projectListing$proje = projectListing.projectsListing) === null || _projectListing$proje === void 0 ? void 0 : _projectListing$proje.projects,
    userActive: userActive,
    setUserActive: setUserActive,
    projectActive: projectActive,
    setProjectActive: setProjectActive,
    type: "project",
    setTaskActive: setTaskActive,
    taskActive: taskActive
  })))), projectActive.length ? /*#__PURE__*/React.createElement(Dropdown, {
    open: isNavClick,
    className: classNames("project-report-users-button .btn-primary")
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basics"
  }, "Task ", taskActive.length ? " (".concat(taskActive.length, ") ") : null, " "), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: "project-report-dropdown-menu-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-report-drop-text"
  }, /*#__PURE__*/React.createElement(ProjectAndTaskList, {
    isNavClick: isNavClick,
    setNavClick: setNavClick,
    projectListing: projectListing === null || projectListing === void 0 ? void 0 : (_projectListing$proje2 = projectListing.projectsListing) === null || _projectListing$proje2 === void 0 ? void 0 : _projectListing$proje2.projects,
    userActive: userActive,
    setUserActive: setUserActive,
    projectActive: projectActive,
    setProjectActive: setProjectActive,
    type: "task",
    setTaskActive: setTaskActive,
    taskActive: taskActive
  })))) : null), /*#__PURE__*/React.createElement("div", null, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? !exportButton ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      getExportData();
    }
    //onClick={(e) => saveAsExcel()}
    ,
    className: "daily-attendance-filter-download-icon-btn"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), " Export") : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    className: "daily-attendance-filter-download-icon-btn"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), "Downloading") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export report")
  }, /*#__PURE__*/React.createElement("div", {
    className: " disable-timesheet"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), " Export"))))), taskTrackerLoading ? /*#__PURE__*/React.createElement("div", {
    className: "desktop-home-project-card-root-list-section-body"
  }, /*#__PURE__*/React.createElement(Loader, null)) : taskTrackerError ? /*#__PURE__*/React.createElement("div", {
    className: "desktop-home-project-card-root-list-section-body"
  }, " ", /*#__PURE__*/React.createElement("p", null, "Something went wrong, please refresh the page.")) : dataTable !== null && dataTable !== void 0 && dataTable.length ? /*#__PURE__*/React.createElement(TableGrid, {
    columns: columns,
    data: dataTable,
    handleLoadMore: handleLoadMore,
    isAllLoaded: isAllLoaded,
    isLoadingMore: isLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    userActive: userActive,
    totalWorkedHours: taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getR7 = taskTrackerData.getReportTaskTrackerDetails) === null || _taskTrackerData$getR7 === void 0 ? void 0 : _taskTrackerData$getR7.totalWorkedHours,
    totalBillableRate: taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getR8 = taskTrackerData.getReportTaskTrackerDetails) === null || _taskTrackerData$getR8 === void 0 ? void 0 : _taskTrackerData$getR8.totalBillableRate,
    totalLabourCost: taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getR9 = taskTrackerData.getReportTaskTrackerDetails) === null || _taskTrackerData$getR9 === void 0 ? void 0 : _taskTrackerData$getR9.totalLabourCost,
    totalProfit: taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getR10 = taskTrackerData.getReportTaskTrackerDetails) === null || _taskTrackerData$getR10 === void 0 ? void 0 : _taskTrackerData$getR10.totalProfit
  }) :
  /*#__PURE__*/
  // </>
  React.createElement("div", {
    className: "project-report-no-data"
  }, "No data found.")));
};
var TableGrid = function TableGrid(props) {
  var columns = props.columns,
    data = props.data,
    handleLoadMore = props.handleLoadMore,
    isAllLoaded = props.isAllLoaded,
    isLoadingMore = props.isLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    userActive = props.userActive,
    totalWorkedHours = props.totalWorkedHours,
    totalBillableRate = props.totalBillableRate,
    totalLabourCost = props.totalLabourCost,
    totalProfit = props.totalProfit;
  var _useTable = useTable({
      columns: columns,
      data: data
    }, useSortBy),
    getTableProps = _useTable.getTableProps,
    getTableBodyProps = _useTable.getTableBodyProps,
    headerGroups = _useTable.headerGroups,
    rows = _useTable.rows,
    prepareRow = _useTable.prepareRow;
  return /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-content"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("table", _extends({}, getTableProps(), {
    className: "daily-attendance-table"
  }), /*#__PURE__*/React.createElement("thead", null, headerGroups.map(function (headerGroup) {
    return /*#__PURE__*/React.createElement("tr", headerGroup.getHeaderGroupProps(), headerGroup.headers.map(function (column) {
      // Add the sorting props to control sorting. For this example
      // we can add them into the header props
      return /*#__PURE__*/React.createElement("th", _extends({}, column.getHeaderProps(column.getSortByToggleProps()), {
        className: "project-report-react-table-thead-".concat(column.id)
      }), column.render("Header"), /*#__PURE__*/React.createElement("span", null, " ", column.isSorted ? column.isSortedDesc ? /*#__PURE__*/React.createElement(HiChevronUp, {
        className: "app-usage-datas-thead-sort-icon"
      }) : /*#__PURE__*/React.createElement(HiChevronDown, {
        className: "app-usage-datas-thead-sort-icon"
      }) : /*#__PURE__*/React.createElement(HiOutlineSelector, {
        className: "app-usage-datas-thead-sort-icon"
      })));
    }));
  })), /*#__PURE__*/React.createElement("tbody", getTableBodyProps(), rows.map(function (row, i) {
    prepareRow(row);
    return /*#__PURE__*/React.createElement("tr", row.getRowProps(), row.cells.map(function (cell) {
      return /*#__PURE__*/React.createElement("td", cell.getCellProps(), cell.render("Cell"));
    }));
  }), /*#__PURE__*/React.createElement("tr", {
    className: "project-report-total-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    className: "project-report-total-td"
  }, "Total Worked Hours "), /*#__PURE__*/React.createElement("td", {
    className: "project-report-total-hours-td"
  }, totalWorkedHours), totalBillableRate !== "$0" ? /*#__PURE__*/React.createElement("td", {
    className: "project-report-total-hours-td"
  }, totalBillableRate) : /*#__PURE__*/React.createElement("td", null), totalLabourCost !== "$0" ? /*#__PURE__*/React.createElement("td", {
    className: "project-report-total-hours-td"
  }, totalLabourCost) : /*#__PURE__*/React.createElement("td", null), totalProfit !== "$0" ? /*#__PURE__*/React.createElement("td", {
    className: "project-report-total-hours-td"
  }, totalProfit) : /*#__PURE__*/React.createElement("td", null)), !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", {
    colSpan: 9,
    className: "daily-attendance-table-load-more-td-load-more-btn"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)))) : /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", {
    colSpan: 9,
    className: "daily-attendance-table-load-more-td-load-more-btn"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    },
    className: "daily-attendance-table-load-more-btn"
  }, "Load more")))) : !(userActive !== null && userActive !== void 0 && userActive.length) ? /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", {
    colSpan: 9,
    className: "daily-attendance-table-load-more-td-load-more-btn"
  }, /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the data"))) : /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", {
    colSpan: 9,
    className: "daily-attendance-table-load-more-td-load-more-btn"
  }, /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the data")))))));
};
var ProjectAndTaskList = function ProjectAndTaskList(props) {
  var _userWithSearch, _userWithSearch2, _projectWithSearch, _projectWithSearch2, _taskWithSearch, _taskWithSearch2;
  var isNavClick = props.isNavClick,
    setNavClick = props.setNavClick,
    projectListing = props.projectListing,
    userActive = props.userActive,
    setUserActive = props.setUserActive,
    projectActive = props.projectActive,
    setProjectActive = props.setProjectActive,
    type = props.type,
    setTaskActive = props.setTaskActive,
    taskActive = props.taskActive;
  var _React$useState21 = React.useState(""),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    searchUser = _React$useState22[0],
    setSearchUser = _React$useState22[1]; // SEARCH SETTINGS

  var userWithSearch = function userWithSearch(userData) {
    if (!searchUser) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$disp, _filterUsersData$disp2, _filterUsersData$disp3, _filterUsersData$disp4;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$disp = filterUsersData.displayName) === null || _filterUsersData$disp === void 0 ? void 0 : (_filterUsersData$disp2 = _filterUsersData$disp.toLowerCase) === null || _filterUsersData$disp2 === void 0 ? void 0 : (_filterUsersData$disp3 = _filterUsersData$disp2.call(_filterUsersData$disp)) === null || _filterUsersData$disp3 === void 0 ? void 0 : (_filterUsersData$disp4 = _filterUsersData$disp3.includes) === null || _filterUsersData$disp4 === void 0 ? void 0 : _filterUsersData$disp4.call(_filterUsersData$disp3, searchUser.toLowerCase());
    });
  };
  var projectWithSearch = function projectWithSearch(userData) {
    if (!searchUser) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$proj, _filterUsersData$proj2, _filterUsersData$proj3, _filterUsersData$proj4;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$proj = filterUsersData.projectName) === null || _filterUsersData$proj === void 0 ? void 0 : (_filterUsersData$proj2 = _filterUsersData$proj.toLowerCase) === null || _filterUsersData$proj2 === void 0 ? void 0 : (_filterUsersData$proj3 = _filterUsersData$proj2.call(_filterUsersData$proj)) === null || _filterUsersData$proj3 === void 0 ? void 0 : (_filterUsersData$proj4 = _filterUsersData$proj3.includes) === null || _filterUsersData$proj4 === void 0 ? void 0 : _filterUsersData$proj4.call(_filterUsersData$proj3, searchUser.toLowerCase());
    });
  };
  var taskWithSearch = function taskWithSearch(userData) {
    if (!searchUser) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$task, _filterUsersData$task2, _filterUsersData$task3, _filterUsersData$task4;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$task = filterUsersData.taskName) === null || _filterUsersData$task === void 0 ? void 0 : (_filterUsersData$task2 = _filterUsersData$task.toLowerCase) === null || _filterUsersData$task2 === void 0 ? void 0 : (_filterUsersData$task3 = _filterUsersData$task2.call(_filterUsersData$task)) === null || _filterUsersData$task3 === void 0 ? void 0 : (_filterUsersData$task4 = _filterUsersData$task3.includes) === null || _filterUsersData$task4 === void 0 ? void 0 : _filterUsersData$task4.call(_filterUsersData$task3, searchUser.toLowerCase());
    });
  };
  var taskList = [];
  React.useEffect(function () {
    projectListing.map(function (item) {
      var projectName = item.projectName,
        projectId = item.projectId,
        tasks = item.tasks;
      if (projectActive.includes(projectId)) {
        tasks === null || tasks === void 0 ? void 0 : tasks.map(function (data) {
          return taskList.push({
            taskName: data.taskName,
            taskId: data.taskId
          });
        });
      }
    });
  }, [projectActive]);
  if (type == "task") {
    projectListing.map(function (item) {
      var projectName = item.projectName,
        projectId = item.projectId,
        tasks = item.tasks;
      if (projectActive.includes(projectId)) {
        tasks === null || tasks === void 0 ? void 0 : tasks.map(function (data) {
          return taskList.push({
            taskName: data.taskName,
            taskId: data.taskId
          });
        });
      }
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "navbar-collapse-project-task-list-card-searchbox-wrapper"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    value: searchUser,
    onChange: setSearchUser,
    placeholder: type == "project" ? "Search project name" : type === "user" ? "Search employee name" : "Search task name"
  })), /*#__PURE__*/React.createElement("div", {
    className: "navbar-collapse-project-task-list-card-searchbox-wrapper-div"
  }), /*#__PURE__*/React.createElement("div", {
    id: "project-and-task-selection-navbar",
    className: "navbar-collapse-project-task project-and-task-selection-navbar-collapse project-and-task-selection-collapse ".concat(isNavClick ? "in" : "")
  }, type == "user" ? projectListing && (_userWithSearch = userWithSearch(projectListing)) !== null && _userWithSearch !== void 0 && _userWithSearch.length ? (_userWithSearch2 = userWithSearch(projectListing)) === null || _userWithSearch2 === void 0 ? void 0 : _userWithSearch2.map(function (user, index) {
    var teamFirstName = user.displayName.match(/\b(\w)/g);
    var teamNameIcon = teamFirstName.join("");
    return /*#__PURE__*/React.createElement(React.Fragment, null, index === 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox"
      //id={user.userId}
      ,
      name: "myRadioGroup",
      className: "project-report-team-selection-control-checkbox",
      checked: !userActive.length,
      onChange: function onChange() {
        setUserActive([]);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, "A"), /*#__PURE__*/React.createElement("div", {
      className: "projects-report-modal-content-header-team-name",
      onClick: function onClick() {
        setUserActive([]);
      }
    }, "All Members"))), /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.userId,
      name: "myRadioGroup",
      className: "project-report-team-selection-control-checkbox",
      checked: userActive.includes(user.userId),
      onChange: function onChange() {
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    }), user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "task-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: user === null || user === void 0 ? void 0 : user.profileUrl,
      className: "task-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, user.displayName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
      className: "projects-report-modal-content-header-team-name",
      onClick: function onClick() {
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    }, user.displayName)))) : /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.userId,
      name: "myRadioGroup",
      className: "project-report-team-selection-control-checkbox",
      checked: userActive.includes(user.userId),
      onChange: function onChange() {
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    }), user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "task-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: user === null || user === void 0 ? void 0 : user.profileUrl,
      className: "task-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, user.displayName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
      className: "projects-report-modal-content-header-team-name",
      onClick: function onClick() {
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    }, user.displayName))));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "text-muted text-center"
  }, "No member found for \"".concat(searchUser, "\" ")) : type == "project" ? projectListing && (_projectWithSearch = projectWithSearch(projectListing)) !== null && _projectWithSearch !== void 0 && _projectWithSearch.length ? (_projectWithSearch2 = projectWithSearch(projectListing)) === null || _projectWithSearch2 === void 0 ? void 0 : _projectWithSearch2.map(function (user, index) {
    var teamFirstName = user.projectName.match(/\b(\w)/g);
    var teamNameIcon = teamFirstName.join("");
    return /*#__PURE__*/React.createElement(React.Fragment, null, index === 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox"
      //id={user.userId}
      ,
      name: "myRadioGroup",
      className: "project-report-team-selection-control-checkbox",
      checked: !projectActive.length,
      onChange: function onChange() {
        setProjectActive([]);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, "A"), /*#__PURE__*/React.createElement("div", {
      className: "projects-report-modal-content-header-team-name",
      onClick: function onClick() {
        setProjectActive([]);
      }
    }, "All projects"))), /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.userId,
      name: "myRadioGroup",
      className: "project-report-team-selection-control-checkbox",
      checked: projectActive.includes(user.projectId),
      onChange: function onChange() {
        setProjectActive(function (prev) {
          return prev.includes(user.projectId) ? prev.filter(function (a) {
            return a !== user.projectId;
          }) : [].concat(_toConsumableArray(prev), [user.projectId]);
        });
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, user.projectName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
      className: "projects-report-modal-content-header-team-name",
      onClick: function onClick() {
        setProjectActive(function (prev) {
          return prev.includes(user.projectId) ? prev.filter(function (a) {
            return a !== user.projectId;
          }) : [].concat(_toConsumableArray(prev), [user.projectId]);
        });
      }
    }, user.projectName)))) : /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.userId,
      name: "myRadioGroup",
      className: "project-report-team-selection-control-checkbox",
      checked: projectActive.includes(user.projectId),
      onChange: function onChange() {
        setProjectActive(function (prev) {
          return prev.includes(user.projectId) ? prev.filter(function (a) {
            return a !== user.projectId;
          }) : [].concat(_toConsumableArray(prev), [user.projectId]);
        });
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, user.projectName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
      className: "projects-report-modal-content-header-team-name",
      onClick: function onClick() {
        setProjectActive(function (prev) {
          return prev.includes(user.projectId) ? prev.filter(function (a) {
            return a !== user.projectId;
          }) : [].concat(_toConsumableArray(prev), [user.projectId]);
        });
      }
    }, user.projectName))));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "text-muted text-center"
  }, "No project found for \"".concat(searchUser, "\" ")) : (_taskWithSearch = taskWithSearch(taskList)) !== null && _taskWithSearch !== void 0 && _taskWithSearch.length ? (_taskWithSearch2 = taskWithSearch(taskList)) === null || _taskWithSearch2 === void 0 ? void 0 : _taskWithSearch2.map(function (user, index) {
    var teamFirstName = user.taskName.match(/\b(\w)/g);
    var teamNameIcon = teamFirstName.join("");
    return /*#__PURE__*/React.createElement(React.Fragment, null, index === 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.taskId,
      name: "myRadioGroup",
      className: "project-report-team-selection-control-checkbox",
      checked: !taskActive.length,
      onChange: function onChange() {
        setTaskActive([]);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, "A"), /*#__PURE__*/React.createElement("div", {
      className: "projects-report-modal-content-header-team-name",
      onClick: function onClick() {
        setTaskActive([]);
      }
    }, "All tasks"))), /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.taskId,
      name: "myRadioGroup",
      className: "project-report-team-selection-control-checkbox",
      checked: taskActive.includes(user.taskId),
      onChange: function onChange() {
        setTaskActive(function (prev) {
          return prev.includes(user.taskId) ? prev.filter(function (a) {
            return a !== user.taskId;
          }) : [].concat(_toConsumableArray(prev), [user.taskId]);
        });
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, user.taskName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
      className: "projects-report-modal-content-header-team-name",
      onClick: function onClick() {
        setTaskActive(function (prev) {
          return prev.includes(user.taskId) ? prev.filter(function (a) {
            return a !== user.taskId;
          }) : [].concat(_toConsumableArray(prev), [user.taskId]);
        });
      }
    }, user.taskName)))) : /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.taskId,
      name: "myRadioGroup",
      className: "project-report-team-selection-control-checkbox",
      checked: taskActive.includes(user.taskId),
      onChange: function onChange() {
        setTaskActive(function (prev) {
          return prev.includes(user.taskId) ? prev.filter(function (a) {
            return a !== user.taskId;
          }) : [].concat(_toConsumableArray(prev), [user.taskId]);
        });
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, user.taskName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
      className: "projects-report-modal-content-header-team-name",
      onClick: function onClick() {
        setTaskActive(function (prev) {
          return prev.includes(user.taskId) ? prev.filter(function (a) {
            return a !== user.taskId;
          }) : [].concat(_toConsumableArray(prev), [user.taskId]);
        });
      }
    }, user.taskName))));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "text-muted text-center"
  }, "No task found for \"".concat(searchUser, "\" "))));
};
export default ProjectReport;